import { atom } from 'nanostores'
import type { CurrencyReward } from '~/lib/currency-reward'

// Holds the currency rewards to celebrate after a Boosting Pack purchase, or
// null when the reward queue is closed. Set from the (decoupled) purchase hook
// and consumed by <BoostingPackRewardQueue>.
export const $boostingPackReward = atom<CurrencyReward[] | null>(null)

export const openBoostingPackReward = (rewards: CurrencyReward[]) => {
  if (rewards.length === 0) return
  $boostingPackReward.set(rewards)
}

export const closeBoostingPackReward = () => {
  $boostingPackReward.set(null)
}
